import * as Sentry from '@sentry/react';

import { isSentryEnabled } from '../logging';
import stripUndefinedProps from '../stripUndefinedProps';

const getFingerPrint = (fingerprint, unique) => {
  const timestamp = new Date().getTime();

  if (fingerprint) {
    return unique ? [...fingerprint, timestamp] : fingerprint;
  }

  return unique ? timestamp : fingerprint;
};

const captureMessage = (message, options = {}, unique = false) => {
  const {
    tags,
    extra,
    contexts,
    user,
    level,
    fingerprint,
    ...others
  } = options;

  const sentryOptions = stripUndefinedProps({
    tags,
    extra,
    contexts,
    user,
    level,
    fingerprint: getFingerPrint(fingerprint, unique),
  });

  if (!isSentryEnabled()) {
    // eslint-disable-next-line
    console.error('captureMessage:', message, sentryOptions);
    return;
  }

  // set the additional data
  Sentry.setExtras(others);
  Sentry.captureMessage(message, sentryOptions);
};

export default captureMessage;
